











import { defineComponent, ref } from "@vue/composition-api";
import { InputStorySearch } from "@scrile/api-provider/dist/api/StoriesProvider";
import { Story } from "@scrile/api-provider/dist/projects/scrileConnect/StoriesProvider";
import useAuthUser from "@/hooks/useAuthUser";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { ViewArchivedStoriesSettings } from "@/types";
import { EVENTS } from "@/const";
import StoriesArchiveView from "./components/StoriesArchiveView.vue";
import { defaultSort, storiesPerPage } from "./config";

export default defineComponent({
  name: "PageStoriesArchive",
  components: { StoriesArchiveView },
  setup() {
    const selectedSort = ref(defaultSort);
    const loading = ref(false);

    const { authUserStrict } = useAuthUser();
    const {
      enableScroll: enableScrollStories,
      items: stories,
      getNextPage: getNextPageStories,
      getFirstPage: getFirstPageStories,
    } = usePager<Story, InputStorySearch>((page, data) =>
      providers.StoriesProvider.searchStories({
        data: { size: storiesPerPage, archived: true, page, sort: selectedSort.value, ...data },
      })
    );

    const getNextPage = async (cb?: () => Promise<void>) => {
      await getNextPageStories(cb, { ownerIds: [authUserStrict.value.id] }).finally(() => cb && cb());
    };

    const getData = async () => {
      try {
        loading.value = true;
        await getFirstPageStories({ ownerIds: [authUserStrict.value.id] });
      } catch (e) {
      } finally {
        loading.value = false;
      }
    };
    const handleSort = (newSort: string) => {
      selectedSort.value = newSort;
      getData();
    };

    const handleStoryClick = (story: Story) => {
      if (!story.contentFeed) return;
      emitter.emit<ViewArchivedStoriesSettings>(EVENTS.ARCHIVED_STORIES_SHOW, {
        stories: stories,
        currentStoryId: story.id,
        cb: getNextPage,
      });
    };

    getData();

    return {
      stories,
      loading,
      selectedSort,
      enableScrollStories,
      handleSort,
      getNextPage,
      handleStoryClick,
    };
  },
});
